import throttle from 'lodash.throttle';
import g from '#core/global';
import load from '#core/load';
import layout from '#core/layout';
import masthead from '#partial/masthead/masthead';


const switch_$ = '[data-bg-switch]';
const palette_attr = 'data-bg-switch-palette';
const lookaround_attr = 'data-bg-switch-lookaround';

let has_switch = false;
let $switches = null;
let global_color = null;


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('background-switch')) return false;
		
		load.content(() => {
			has_switch = assign_elements();
			if (!has_switch) return false;
		});
		load.all(() => {
			has_switch = assign_elements();
			if (!has_switch) return false;
			
			assign_scroll_events();
			update_bg_color();
		});
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_switch) return true;
	
	$switches = document.querySelectorAll(switch_$);
	if (!$switches.length) return false;
	
	return true;
}


/**
 * Assign scroll events
 */
function assign_scroll_events() {
	window.addEventListener(g.scroll_e, throttle(() => {
		update_bg_color();
	}, 250));
}


/**
 * Update background color
 */
function update_bg_color() {
	let new_color = null;
	Array.from($switches).every($switch => {
		const is_intersecting = layout.isIntersecting({
			$element: $switch,
			lookaround: parseFloat($switch.getAttribute(lookaround_attr)),
			top_only: true,
		});
		if (!is_intersecting) return false;
		
		const color = $switch.getAttribute(palette_attr);
		new_color = color;
		return true;
	});
	
	if (new_color === global_color) return false;
	
	global_color = new_color;
	masthead.setBodyPalette(global_color);
}
